import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router';

import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { trackFeaturedCatalogClick } from '@/redux/modules/analytics';
import { getCatalogSellerId, getCatalogTitle } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { AmpProduct, useTrackAmpClicked } from '@/utils/amplitude/analytics';
import { getCatalogUrl } from '@/utils/urls';

export const useTrackAndNavigateCatalogCardClick = (catalogId: number) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const trackAmpClicked = useTrackAmpClicked();

    const title = useAppSelector((state) => getCatalogTitle(state, catalogId));
    const catalogUrl = useMemo(() => getCatalogUrl(catalogId, title), [catalogId, title]);
    const houseId = useAppSelector((state) => getCatalogSellerId(state, catalogId));

    return useCallback(() => {
        dispatch(trackFeaturedCatalogClick(catalogId));
        trackAmpClicked({
            ampProduct: AmpProduct.FeaturedAuctions,
            catalogId,
            houseId,
        });
        navigate(catalogUrl);
    }, [catalogId, catalogUrl, dispatch, houseId, navigate, trackAmpClicked]);
};
